import { UserOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { ROUTES } from '../const/routes';

const NewStudentButton: React.FC = () => (
	<Link to={ROUTES.APP.NEW_STUDENT}>
		<Button type="primary" icon={<UserOutlined />}>
			Nový žák
		</Button>
	</Link>
);

export default NewStudentButton;
